import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom'
import { pagesWithNoFooter, pagesWithNoNavbar } from '../pageLayoutConfig'
import { UsePageLayoutReturnProps } from '../PageLayoutProps'

/**
 * Hook który na podstawie obecnego adresu url, ustala czy pokazywać stopkę i navbara na stronie czy nie
 * @returns {showFooter, showNavbar}
 */
const usePageLayoutLogic = (): UsePageLayoutReturnProps => {
   const location = useLocation()
   const [showFooter, setShowFooter] = useState<boolean>(false)
   const [showNavbar, setShowNavbar] = useState<boolean>(false)

   useEffect(() => {
      // >>>>> Czy wyświetlamy navbara na stronie
      if(pagesWithNoNavbar.includes(location.pathname)){
         setShowNavbar(false)
      }
      else {
         setShowNavbar(true)
      }

      // >>>>> Czy wyświetlamy stopkę na stronie
      if(pagesWithNoFooter.includes(location.pathname)){
         setShowFooter(false)
      }
      else {
         setShowFooter(true)
      }

   }, [location.pathname])


   return { showFooter, showNavbar }
}

export default usePageLayoutLogic